import { OpenAPI as LifeOpenAPI } from '@festina/life-general-types/life-test'
import { useFetchLifeTime as useFetchTimeApi } from '@festina-life/api'
import { useAuthenticationContext } from '@festina-life/authentication'

export const useTime = () => {
  const { isInTestMode } = useAuthenticationContext()

  return useFetchTimeApi(
    {},
    {
      enabled: isInTestMode && !!LifeOpenAPI.BASE,
      select: (data) => data ?? new Date().toISOString(),
    },
  )
}
